/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Route-Outline Icon component.
 */
export const AssetRouteOutlinedIcon = (props: IconProps) => {
  const {color, size = IconSize.large, stroke} = props;
  const {iconSize} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <path d="M12.6958 10.8701H24.821C26.0608 10.8701 27.2499 11.3627 28.1265 12.2394C29.0032 13.1161 29.4957 14.3051 29.4957 15.5449C29.4971 16.1592 29.3771 16.7677 29.1427 17.3355C28.9083 17.9033 28.564 18.4192 28.1296 18.8536C27.6952 19.2879 27.1794 19.6322 26.6116 19.8667C26.0438 20.1011 25.4353 20.2211 24.821 20.2197H19.1444H13.4575C12.2185 20.2225 11.031 20.7158 10.155 21.5919C9.27886 22.468 8.78547 23.6555 8.78271 24.8945C8.78271 26.1343 9.27521 27.3234 10.1519 28.2C11.0286 29.0767 12.2176 29.5693 13.4575 29.5693H27.3045" stroke={stroke as any} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="29.3914" cy="29.3909" r="1.8587" stroke={stroke as any} strokeWidth="1.5"/>
      <circle cx="10.6087" cy="10.6087" r="1.8587" stroke={stroke as any} strokeWidth="1.5"/>
    </svg>
  );
};

export default AssetRouteOutlinedIcon;
